<template>
  <section class="feedback">
    <show-scratch-card
      :scratchArrayValue="scratchArrayValue"
      :scratchSaleId="this.$route.query.orderId"
      :redeemId="scratchArrayValue.id"
      @closeScratch="closeScratch"
      :appId="1"
      v-if="isCloseScratch"
    />
    <div class="text">
      <p>{{$t('feedbackThanksYouMsg')}}</p>
    </div>
    <div class="img-block">
      <span class="img" @click="goToProductDetail(orderDetails.itemId)">
        <img :src="orderDetails.displayImage" alt />
      </span>
      <span class="stars">
        <star-rating
          :starSize="25"
          :rating="Number(orderDetails.avgRating)"
          active-color="#138808"
          read-only
          :show-rating="false"
        ></star-rating>
      </span>
    </div>
    <router-link tag="span" :to="{ path: '/manage-shops'}" class="btn">{{$t('goToOrderPage')}}</router-link>
  </section>
</template>
<script>
import StarRating from "vue-star-rating";
import constant from "../../utils/constant";
import ApiCaller from "../../utils/apicaller";
import ShowScratchCard from "../../components/OrderHistorySection/ShowScratchCard";
export default {
  name: "FeedbackResult",
  components: {
    StarRating,
    ShowScratchCard
  },
  data() {
    return {
      orderDetails: {},
      isCloseScratch: false,
      scratchArrayValue: {}
    };
  },

  methods: {
    goToProductDetail(id) {
      this.$router.push("/detail/" + id);
    },
    getOrderFeedback() {
      this.loading = true;
      ApiCaller(
        constant.PRODUCT_RATING,
        "get-order-rating-by-user/" + this.$route.params.orderId,
        "get"
      )
        .then(data => {
          this.loading = false;
           this.orderDetails = data.data;
          setTimeout(() => {
            if (!this.$route.query.ratingId) {
              this.getScratchValue();
            }
          }, 1000);         
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    closeScratch() {
      this.isCloseScratch = !this.isCloseScratch;
    },
    getScratchValue() {
      const obj = {
        identifierSource: "PRODUCT_RATING",
        identifierId: this.orderDetails.id,
        applicationId: "1"
      };
      this.$store
        .dispatch({
          type: "getScratchValue",
          payload: obj
        })
        .then(data => {
          if (data) {
            this.isCloseScratch = true;
            if (
              data &&
              data.data.status == "ACTIVE" &&
              data.data.scratchcardDTO.cardStatus == "INVISIBLE"
            ) {
              
              this.scratchArrayValue = data.data;
            } else if (
              this.scratchArray.status == "ACTIVE" &&
              this.scratchArray.scratchcardDTO.cardStatus == "ACTIVE"
            ) {
              this.scratchArrayValue = data.data;
            }
          } else {
            console.log("already scracthed");
          }
        }).catch(err =>{
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = res => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.getScratchCard();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }
        })
    }
  },
  mounted() {
    this.getOrderFeedback();
  }
};
</script>
<style lang="scss" scoped>
.feedback {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  .text {
    margin-bottom: -120px;
    padding-top: 80px;
    text-align: center;
    p {
      font-size: 1.1em;
      line-height: 26px;
      padding: 0 45px;
    }
  }
  .img-block {
    text-align: center;
    .img {
      display: block;
      height: 100px;
      width: 100px;
      border-radius: 50%;
      overflow: hidden;
      margin: 0 auto;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .stars {
      padding-top: 10px;
      display: block;
    }
  }
  .btn {
    width: 100%;
    background-color: #118709;
    padding: 10px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    font-size: 0.875em;
  }
}
</style>